(() => {
  function initTabs(root = document) {
    root.querySelectorAll('.product-tabs').forEach((wrap) => {
      if (wrap.dataset.tabsBound === '1') return;
      wrap.dataset.tabsBound = '1';
      const tabs = Array.from(wrap.querySelectorAll('.product-tabs__tab'));
      const panels = Array.from(wrap.querySelectorAll('.product-tabs__panel'));
      if (!tabs.length || !panels.length) return;
      function activate(tab, options = {}) {
        const { focus = false, updateHash = false } = options;
        const targetId = tab.getAttribute('aria-controls');
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach((panel) => {
          const active = panel.id === targetId;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
        if (focus) tab.focus();
        if (updateHash && targetId) history.replaceState(null, '', `#${targetId}`);
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab, { updateHash: true }));
        tab.addEventListener('keydown', (event) => {
          const key = event.key;
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (key === 'Home') nextIndex = 0;
          if (key === 'End') nextIndex = tabs.length - 1;
          activate(tabs[nextIndex], { focus: true, updateHash: true });
        });
      });
      const hash = window.location.hash.replace('#', '');
      const hashTab = tabs.find((tab) => tab.id === hash || tab.getAttribute('aria-controls') === hash);
      activate(hashTab || tabs[0]);
    });
  }
  document.addEventListener('DOMContentLoaded', () => initTabs(document));
  document.addEventListener('shopify:section:load', (e) => initTabs(e.target));
})();